import React from 'react';
import { useSessionTimer } from '../hooks/useSessionTimer';
import { salesProof } from '../data/salesProof';
const pad = (n: number) => String(n).padStart(2, '0');
export function OfferTimer({
  className = ''
}: {
  className?: string;
}) {
  const minutesTotal = salesProof.offerTimerMinutes;
  const {
    minutes,
    seconds,
    ended
  } = useSessionTimer(minutesTotal);
  if (minutesTotal <= 0) return null;
  const units = [{
    value: pad(minutes),
    label: 'min'
  }, {
    value: pad(seconds),
    label: 'seg'
  }];
  return <div className={`rounded-2xl bg-pink/15 px-4 py-4 ring-1 ring-pink/40 sm:px-5 ${className}`} data-id="element-254" data-mp="hywcyh1m2lu9">
      <p className="font-display text-[15px] font-extrabold text-white sm:text-base" data-id="element-255" data-mp="3zmufapxnfn4">🔥 Oferta por tiempo limitado 🔥</p>
      {ended ? <p className="mt-2 text-sm font-semibold text-white/90" data-id="element-256" data-mp="91caj4s0iji2">El tiempo de tu oferta terminó. Aprovechá este precio mientras siga disponible.</p> : <>
          <p className="mt-1 text-sm text-white/80" data-id="element-257" data-mp="2trbd0yqag0da">Este precio se mantiene reservado para vos durante:</p>
          <div className="mt-3 flex items-start justify-center gap-2" role="timer" aria-label={`Quedan ${minutes} minutos y ${seconds} segundos`} data-id="element-258" data-mp="1he5j9l0led3v">
            {units.map((u, i) => <React.Fragment key={u.label} data-id="element-259" data-mp="1rdmo6080smys" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" className="pt-1.5 font-heading text-2xl font-black text-white/50" data-id="element-260" data-mp="1mcp4tkb9xmvp">
                    :
                  </span>}
                <div className="flex min-w-[64px] flex-col items-center rounded-xl bg-navy px-2 py-2 ring-1 ring-white/15" data-id="element-261" data-mp="1wbee4op3tz0c">
                  <span aria-hidden="true" className="font-heading text-[1.75rem] font-black tabular-nums leading-none text-white sm:text-3xl" data-id="element-262" data-mp="2a2t279xvcqe9">
                    {u.value}
                  </span>
                  <span aria-hidden="true" className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-teal-light" data-id="element-263" data-mp="2jzxkuzsia3qb">
                    {u.label}
                  </span>
                </div>
              </React.Fragment>)}
          </div>
        </>}
    </div>;
}